'use strict';


import { Float32BufferAttribute, Vector2, Vector3 } from 'three';

export class PlanarUV {

    constructor (geometry) {
        this.geometry = geometry;

        this.geometry.computeBoundingBox();

        const max = this.geometry.boundingBox.max;
        const min = this.geometry.boundingBox.min;

        const offset = new Vector2(0 - min.x, 0 - min.y);
        const range = new Vector2(max.x - min.x, max.y - min.y);

        const uv = [];

        const positionAttribute = this.geometry.getAttribute('position');

        const vertex = new Vector3();

        for (let i = 0; i < positionAttribute.count; i ++) {
            vertex.fromBufferAttribute(positionAttribute,i);
            const u = (vertex.x + offset.x) / range.x;
            const v = (vertex.y + + offset.y) / range.y;
            uv.push(u,v);
        }


        return new Float32BufferAttribute(uv,2);
    }

}